// graphql.provider.ts
import { inject } from '@angular/core';
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache, ApolloLink } from '@apollo/client/core';
import { environment } from '../environments/environment';

const uri = `${environment.bffApiUrl}`;

function stripTypenameDeep(value: any): any {
  if (Array.isArray(value)) return value.map(stripTypenameDeep);
  if (value !== null && typeof value === 'object') {
    const result: any = {};
    for (const key of Object.keys(value)) {
      if (key === '__typename') continue;
      result[key] = stripTypenameDeep(value[key]);
    }
    return result;
  }
  return value;
}

const cleanTypenameLink = new ApolloLink((operation, forward) => {
  if (operation.variables) {
    operation.variables = stripTypenameDeep(operation.variables);
  }
  return forward(operation);
});

export function provideGraphQL() {
  return provideApollo(() => {
    const httpLink = inject(HttpLink);
    return {
      cache: new InMemoryCache(),
      link: cleanTypenameLink.concat(httpLink.create({ uri })),
    };
  });
}